var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExcelB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6680)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2641_6680",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2641_6680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3467 17.0906H23.2575V14.546H28.3467V17.0906ZM28.3467 18.5446H23.2575V21.0892H28.3467V18.5446ZM28.3467 6.5487H23.2575V9.09328H28.3467V6.5487ZM28.3467 10.5474H23.2575V13.0919H28.3467V10.5474ZM28.3467 22.5432H23.2575V25.0878H28.3467V22.5432ZM31.8618 27.5597C31.7164 28.3158 30.8076 28.334 30.2006 28.3595H18.8954V31.631H16.6379L0 28.7229V3.28077L16.7362 0.369019H18.8954V3.2662H29.8116C30.426 3.29164 31.1021 3.24801 31.6364 3.61514C32.0109 4.15314 31.9746 4.83658 32 5.45452L31.9855 24.3789C31.9673 25.4368 32.0835 26.5164 31.8618 27.5597ZM13.33 21.8562C12.3266 19.8206 11.3052 17.7994 10.3056 15.7637C11.2943 13.7826 12.2686 11.7942 13.2391 9.80574C12.4139 9.8458 11.5887 9.89661 10.7672 9.95483C10.1529 11.4488 9.43676 12.9029 8.95692 14.4479C8.50984 12.9901 7.91732 11.587 7.37568 10.1656C6.57593 10.2093 5.77619 10.2565 4.9765 10.3037C5.81981 12.165 6.71775 14.0007 7.53563 15.8728C6.57231 17.6904 5.67082 19.5334 4.73657 21.3618C5.53263 21.3945 6.32875 21.4273 7.12481 21.4381C7.69194 19.9914 8.39713 18.5991 8.89151 17.1232C9.33502 18.7082 10.0874 20.1732 10.7055 21.689C11.5815 21.7509 12.4539 21.8053 13.33 21.8562ZM30.2663 4.99264H18.8954V6.5487H21.8035V9.09328H18.8954V10.5474H21.8035V13.0919H18.8954V14.546H21.8035V17.0906H18.8954V18.5446H21.8035V21.0892H18.8954V22.5432H21.8035V25.0878H18.8954V26.7689H30.2663V4.99264Z",
    fill: "#F2F7F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcelB);
export default __webpack_public_path__ + "static/media/IconExcelB.d844a312e255640a7b31a601f6e288a1.svg";
export { ForwardRef as ReactComponent };